import { useEffect, useState } from "react";
import { AppDialog } from "../../../components/common/CustomMdal";
import FormDropdown from "../../../components/common/FormDropdown";

interface SetDivisionsGroupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: (numDivisions: number, numGroups: number) => void;
}

const COUNT_OPTIONS = Array.from({ length: 20 }, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1),
}));

const SetDivisionsGroupModal = ({
  open,
  onOpenChange,
  onCreate,
}: SetDivisionsGroupModalProps) => {
  const [numDivisions, setNumDivisions] = useState("");
  const [numGroups, setNumGroups] = useState("");

  useEffect(() => {
    if (!open) {
      setNumDivisions("");
      setNumGroups("");
    }
  }, [open]);

  const handleCreate = (e: React.FormEvent) => {
    e.preventDefault();
    const d = parseInt(numDivisions, 10);
    const g = parseInt(numGroups, 10);
    if (!d || !g || d < 1 || g < 1) return;
    onCreate(d, g);
    setNumDivisions("");
    setNumGroups("");
    onOpenChange(false);
  };

  const isValid =
    numDivisions.trim() !== "" &&
    numGroups.trim() !== "" &&
    parseInt(numDivisions, 10) >= 1 &&
    parseInt(numGroups, 10) >= 1;

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Set Divisions & Group"
      size="md"
      className="set-divisions-dialog"
    >
      <form onSubmit={handleCreate} className="set-divisions-form">
        <div className="set-divisions-fields">
          <div className="set-divisions-field">
            <label className="set-divisions-label" htmlFor="set-divisions-count">
              Total Number of Division*
            </label>
            <FormDropdown
              id="set-divisions-count"
              value={numDivisions}
              onChange={(v) => setNumDivisions(v)}
              options={COUNT_OPTIONS}
              placeholder="Select"
            />
          </div>

          <div className="set-divisions-field">
            <label className="set-divisions-label" htmlFor="set-groups-count">
              Total Number of Group*
            </label>
            <FormDropdown
              id="set-groups-count"
              value={numGroups}
              onChange={(v) => setNumGroups(v)}
              options={COUNT_OPTIONS}
              placeholder="Select"
            />
          </div>
        </div>

        <div className="set-divisions-footer">
          <button
            type="button"
            className="set-divisions-cancel"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="set-divisions-create"
            disabled={!isValid}
          >
            Create
          </button>
        </div>
      </form>
    </AppDialog>
  );
};

export default SetDivisionsGroupModal;
